function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */
var ButtonGroup = require("react-components/button-group.jsx");
var React = require("react");
var _ = require("underscore");

var _require = require("../../mixins/changeable.jsx"),
    ChangeableProps = _require.ChangeableProps;

var KhanColors = require("../../util/colors.js");

var COLORS = [KhanColors.BLACK, KhanColors.BLUE, KhanColors.GREEN, KhanColors.PINK, KhanColors.PURPLE, KhanColors.RED, KhanColors.GRAY];

var LIGHT_COLORS = [KhanColors.LIGHT_BLUE, KhanColors.LIGHT_ORANGE, KhanColors.LIGHT_PINK, KhanColors.LIGHT_GREEN, KhanColors.LIGHT_PURPLE, KhanColors.LIGHT_RED, "#fff"];

var ColorPicker = function (_React$Component) {
    _inherits(ColorPicker, _React$Component);

    function ColorPicker() {
        _classCallCheck(this, ColorPicker);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }

    ColorPicker.prototype.render = function render() {
        var colors = this.props.lightColors ? LIGHT_COLORS : COLORS;
        return React.createElement(ButtonGroup, {
            value: this.props.value,
            allowEmpty: false,
            buttons: _.map(colors, function (color) {
                return {
                    value: color,
                    content: React.createElement(
                        "span",
                        null,
                        React.createElement("span", {
                            className: "colorpicker-circle",
                            style: { background: color }
                        }),
                        "\xA0"
                    )
                };
            }),
            onChange: this.props.onChange
        });
    };

    return ColorPicker;
}(React.Component);

ColorPicker.defaultProps = {
    value: KhanColors.BLACK,
    lightColors: false
};


module.exports = ColorPicker;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/interaction/color-picker.jsx
 ** module id = 290
 ** module chunks = 0 1
 **/